import { action, observable } from 'mobx';

import customFetch from '../../../utils/customFetch';
import moment from 'moment';
import * as api from '../../../stores/api';

class SupplementaryReportsStore {
  @observable loading = true;
  @observable loadingClaimant = true;
  @observable loadingStaff = true;
  @observable loadingStaffAssignAction = true;
  @observable loadingStaffAssign = true;
  @observable loadingDynamicSRStatus = true;
  @observable loadingDynamicOverDueSRStatus = true;

  @observable data = null;
  @observable dataClaimant = null;
  @observable dataStaff = null;
  @observable dataStaffAssignAction = null;
  @observable dataStaffAssign = null;
  @observable dataDynamicSupplementaryReportStatus = null;
  @observable dataDynamicOverDueSupplementaryReportStatus = null;
  @observable dataPrepayment = null;

  @observable showBookingToday = false;

  @observable keyword = '';
  @observable keywordClaimant = ``;

  @observable sortKey = api.isCaseManager() ? 'DateRequest' : 'StatusDate';
  @observable sortColumn = 'Status Date';
  @observable sortDirection = 'descending';
  @observable filter = `All`;
  @observable searchClaimantOnly = false;
  @observable filterOverdue = `All`;
  @observable actionRequiredById = '';
  @observable fromTo = ``;
  @observable NextTaskPIC = null;
  @observable claimant = { Id: ``, FullName: `` };
  @observable PrepaymentType = 0;

  @observable curPage = 1;
  @observable totalPage = 0;
  @observable totalItems = 0;
  @observable numberSearch = 30;

  @observable open = false;
  @observable modalParams = {};

  @observable bodyForm = null;
  @observable assignStaffs = [];

  @action setFieldsValue = data => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  };

  @action handleSort = ({ sortKey }, { column, direction }) => {
    this.sortColumn = column;
    this.sortDirection = direction;
    this.sortKey = sortKey;
    this.fetchSupplementary();
  };

  @action fetchClaimant = () => {
    this.loadingClaimant = true;
    customFetch('/Supplementary/GetSuggestClaimant', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        keyword: this.keywordClaimant,
        Showing: 'active',
        numItemPerPage: this.numberSearch,
        IsSelectionList: true,
        curPage: 1,
      }),
    }).then(
      action(data => {
        this.dataClaimant = data;
        this.loadingClaimant = false;
      }),
    );
  };

  @action fetchStaff = () => {
    this.loadingStaff = true;
    customFetch('/Supplementary/GetStaffs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        this.dataStaff = data;
        this.loadingStaff = true;
      }),
    );
  };

  @action fetchStaffAssignAction = () => {
    this.loadingStaffAssignAction = true;
    customFetch('/Supplementary/GetStaffsAssignedActionRequired', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        // Action Required
        this.dataStaffAssignAction = data;
        this.loadingStaffAssignAction = true;
      }),
    );
  };

  @action fetchStaffAssign = () => {
    this.loadingStaffAssign = true;
    customFetch('/Supplementary/GetStaffsAssign', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        // NextTaskPIC
        this.dataStaffAssign = data;
        this.loadingStaffAssign = true;
      }),
    );
  };

  @action fetchDynamicSupplementaryReportStatus = () => {
    this.loadingDynamicSRStatus = true;
    customFetch('/Supplementary/GetDynamicSupplementaryStatus', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        // CaseStatus
        this.dataDynamicSupplementaryReportStatus = data;
        this.loadingDynamicSRStatus = true;
      }),
    );
  };

  @action fetchDynamicOverDueSupplementaryReportStatus = () => {
    this.loadingDynamicOverDueSRStatus = true;
    customFetch('/Supplementary/GetDynamicOverDueSupplementaryStatus', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        // Over Due
        this.dataDynamicOverDueSupplementaryReportStatus = data;
        this.loadingDynamicOverDueSRStatus = true;
      }),
    );
  };

  @action fetchPrepayment = () => {
    this.loadingPrepayment = true;
    customFetch('/Supplementary/GetDynamicAssessmentPrepayment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(),
    }).then(
      action(data => {
        this.dataPrepayment = data;
      }),
    );
  };

  getDateRange = () => {
    const [fromDate, toDate] = this.fromTo.split(' - ');
    return {
      fromDate: fromDate ? moment(fromDate, 'DD/MM/YYYY') : '',
      toDate: toDate ? moment(toDate, 'DD/MM/YYYY').toISOString() : '',
    };
  };

  @action fetchSupplementary = (setTotalPage = false) => {
    this.loading = true;
    const { fromDate, toDate } = this.getDateRange();

    let from = '';
    if (fromDate) {
      from = this.showBookingToday ? fromDate.format() : fromDate.toISOString();
    }

    const body = JSON.stringify({
      ActionRequired: false,
      ActionRequiredById: this.actionRequiredById,
      ActionType: 'NONE',
      From: from,
      To: toDate,
      CurPage: this.curPage,
      FilterOverdue: this.filterOverdue,
      FilterType: this.filter,
      ClaimantId: this.claimant.Id,
      Keyword: this.keyword,
      NextPicId: this.NextTaskPIC,
      NumItemPerPage: 20,
      Claimant: this.claimant,
      SearchClaimantOnly: this.searchClaimantOnly,
      SortBy: this.sortKey,
      SortDirection: this.sortDirection.replace('ending', '').toUpperCase(),
      UrgentReport: false,
      FilterPrepayment: this.PrepaymentType,
    });

    customFetch('/Supplementary/Supplementary_LoadList', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
    }).then(
      action(data => {
        this.data = data;
        this.bodyForm = body;
        this.showBookingToday = false;
        if (data.curPage <= 1) {
          this.totalPage = data.sumPage;
          this.totalItems = data.sumItem;
        }
        this.fetchClaimant();
        this.fetchDynamicSupplementaryReportStatus();
        this.fetchStaff();
        this.fetchDynamicOverDueSupplementaryReportStatus();
        this.fetchPrepayment();
        this.fetchStaffAssign();
        this.fetchStaffAssignAction();
        this.loading = false;
      }),
    );
  };

  @action getData = () => {
    this.loading = true;
  };

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };

  @action refetch = (data = {}, setTotalPage = false) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchSupplementary(setTotalPage);
  };

  @action refetchClaimant = (data = {}, setTotalPage = false) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchClaimant(setTotalPage);
  };

  @action resetStore = () => {
    this.keyword = '';
    this.filter = 'All';
    this.sortColumn = 'Status Date';
    this.sortKey = api.isCaseManager() ? 'DateRequest' : 'StatusDate';
    this.sortDirection = 'descending';
    this.searchClaimantOnly = false;
    this.claimant = { Id: ``, FullName: `` };
    this.fromTo = ``;
    this.NextTaskPIC = null;
    this.actionRequiredById = ``;
    this.filterOverdue = `All`;

    this.curPage = 1;
    this.totalPage = 0;
    this.numberSearch = 30;
    this.PrepaymentType = 0;

    this.fetchSupplementary(true);
  };

  @action resetSearch = () => {
    this.numberSearch = 30;
    this.keywordClaimant = '';

    this.refetchClaimant({}, true);
  };
}

export default new SupplementaryReportsStore();
